import { Grid, Fade, Dialog, IconButton, Button } from '@material-ui/core';
import { Dispatch, VFC } from 'react';
import { useStyles } from './useStyles';
import {
  ModalCancelButton,
  ModalDeleteButton,
  ModalSubmitButton
} from '../../parts/cloudStorage/style/style';
import { Close } from '@material-ui/icons';

export type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  title?: string;
  buttonCaption?: string;
  cancelButtonCaption?: string;
  handleSubmit: () => void;
  handleCancelSubmit: () => void;
  handleDeleteSubmit?: () => void;
  children: React.ReactNode;
  isSubmitButton?: boolean;
  isDeleteButton?: boolean;
  isCancelButton?: boolean;
  subDeleteButton?: boolean;
  isCloseIcon?: boolean;
  extraFooter?: React.ReactNode;
  editFlg?: boolean;
};

export const BaseModal: VFC<Props> = props => {
  const {
    isOpen,
    setIsOpen,
    handleSubmit,
    handleCancelSubmit,
    handleDeleteSubmit,
    title,
    buttonCaption,
    cancelButtonCaption,
    children,
    isSubmitButton = true,
    isDeleteButton,
    isCancelButton = true,
    subDeleteButton,
    isCloseIcon = false,
    extraFooter,
    editFlg = true
  } = props;
  const classes = useStyles();

  return (
    <Dialog
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      className={classes.modal}
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      closeAfterTransition
      maxWidth={'sm'}
      fullWidth={true}
    >
      <Fade in={isOpen}>
        <Grid container>
          <Grid item xs={12} style={{ paddingTop: 36, paddingBottom: 36 }}>
            {isCloseIcon && (
              <IconButton
                aria-label='close'
                className={classes.closeIcon}
                onClick={() => {
                  setIsOpen(false);
                }}
                style={{ zIndex: 9999 }}
              >
                <Close />
              </IconButton>
            )}
            {title && <h1 className={classes.modalTitle}>{title}</h1>}
            <Grid container alignItems='center' justify='center'>
              {children}
            </Grid>
          </Grid>
          {(isSubmitButton || isDeleteButton || isCancelButton) && (
            <Grid item xs={12} className={classes.modalFooter}>
              {/* 削除ボタン */}
              {subDeleteButton && editFlg && (
                <Button
                  className={classes.subDeleteButton}
                  variant='contained'
                  onClick={() => {
                    handleDeleteSubmit && handleDeleteSubmit();
                  }}
                >
                  削除
                </Button>
              )}
              {/* /削除ボタン */}
              {/* キャンセルボタン */}
              {isCancelButton && (
                <ModalCancelButton
                  className={
                    subDeleteButton ? classes.adjustButton : classes.button
                  }
                  variant='contained'
                  onClick={handleCancelSubmit}
                >
                  {cancelButtonCaption}
                </ModalCancelButton>
              )}
              {/* /キャンセルボタン */}
              {/* 実行ボタン */}
              {isDeleteButton && editFlg && (
                <ModalDeleteButton
                  className={
                    subDeleteButton ? classes.adjustButton : classes.button
                  }
                  variant='contained'
                  onClick={handleSubmit}
                >
                  {buttonCaption}
                </ModalDeleteButton>
              )}
              {!isDeleteButton && isSubmitButton && editFlg && (
                <ModalSubmitButton
                  className={
                    subDeleteButton ? classes.adjustButton : classes.button
                  }
                  variant='contained'
                  onClick={handleSubmit}
                >
                  {buttonCaption}
                </ModalSubmitButton>
              )}
              {/* /実行ボタン */}
            </Grid>
          )}
          {extraFooter && (
            <Grid item xs={12} className={classes.modalFooter}>
              {extraFooter}
            </Grid>
          )}
        </Grid>
      </Fade>
    </Dialog>
  );
};
